import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { constantConfig } from "web-common";
import { ServicePlusIcon, WayLeftIcon, WayRightIcon } from '../../component/icon/Icon';


import './style/index.less';
import { generateClassName } from "jzfz-web-utils";

const serviceBanner = require('../../assets/images/service/service-bg.jpg');
const serviceBannerFilter = require('../../assets/images/service/service-bg-filter.jpg');

const { WEBSITE_PATHS } = constantConfig;


/**
 * 服务
 * @constructor
 */
const Service = () => {

	const history = useHistory();

	const { isMobile } = useSelector((state: any) => state.reducer); 

	const [banner, setBanner] = useState(serviceBanner);


	useEffect(() => {

		// 滚动后银的滤镜图片
		const handleScrollTop = () => {
			const scrollTopValue = document.documentElement.scrollTop || document.body.scrollTop;
			const tempBanner = scrollTopValue >= 100 ? serviceBannerFilter : serviceBanner;
			setBanner(tempBanner);
		};

		window.addEventListener('scroll', handleScrollTop);

		return () => window.removeEventListener('scroll', handleScrollTop);

	}, []);


	return (
		<div className="company-service-wrapper">
			<div className="pr w ofh">
				<img src={banner} loading="lazy" className={isMobile ? "imagec" : "w"} />
				<div className={generateClassName([isMobile ? "service-content-mobile" : "service-content-pc"])}>
					<div style={{width: isMobile ? '100%' : 824}}>
						<div className="ftl service-title">基准方中2.0</div>
						<p className="desc">遵循市场化原则，践行全面建筑观，围绕“大咨询、大设计、大管理”持续发力，为政企客户提供全过程、全面的专业服务，为项目各方创造更大价值。</p>
						<div className="flexic">
							<div className="h1 ml5 flex1" style={{ background: '#fff' }} />
						</div>

						<div className="service-item">
							<div className="flexjs">
								<span className="service-item-name ftl">大咨询</span>
								<span className="service-item-enName ftl">Consulting & Planning</span>
							</div>
							<div>全过程咨询 | 城乡规划 | 造价咨询 | 设计优化</div>
						</div>

						<div className="service-item">
							<div className="flexjs">
								<span className="service-item-name ftl">大设计</span>
								<span className="service-item-enName ftl">Design</span>
							</div>
							<div>居住 | 商业 | 办公及产业园 | 文化教育 | 酒店 | 医疗康养 | 体育 | TOD | 工业及物流 | 城市更新 | 乡村振兴 | 景观 | 市政 | 室内</div>
						</div>

						<div className="service-item">
							<div className="flexjs">
								<span className="service-item-name ftl">大管理</span>
								<span className="service-item-enName ftl">Management</span>
							</div>
							<div>设计总包 | 工程总承包</div>
						</div>
						
						<div className="flexjs flexic pt24">
							<div><WayLeftIcon className="f36 crp" onClick={() => history.replace(WEBSITE_PATHS.home)} /></div>
							<div className="flexjs flexic crp" onClick={() => history.replace(WEBSITE_PATHS.product)}>
								<div className="tr pr5">
									<div className="f18 ftl">作品</div>
									<div className="f12 ftl">PROJECTS</div>
								</div>
								<WayRightIcon className="f36" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}


export default Service;
